// file-widgets-common.js

/**
 * Настройка drag & drop событий
 */
export function setupDragAndDrop(dropArea, fileInput) {
  ['dragenter','dragover','dragleave','drop'].forEach(evt => {
    dropArea[0].addEventListener(evt, preventDefaults, false);
    document.body.addEventListener(evt, preventDefaults, false);
  });
  ['dragenter','dragover'].forEach(evt =>
    dropArea[0].addEventListener(evt, () => dropArea.addClass('drag-over'), false)
  );
  ['dragleave','drop'].forEach(evt =>
    dropArea[0].addEventListener(evt, () => dropArea.removeClass('drag-over'), false)
  );
  dropArea[0].addEventListener('drop', e => {
    const files = e.dataTransfer.files;
    if (files.length) {
      fileInput[0].files = files;
      fileInput.trigger('change');
    }
  }, false);
}

export function preventDefaults(e) {
  e.preventDefault();
  e.stopPropagation();
}

export function getFileExtension(filename) {
  const parts = filename.split('.');
  return (parts.length > 1 ? parts.pop() : '').toLowerCase();
}

const COLOR_MAP = {
  pdf: 'text-danger',
  doc: 'text-primary', docx: 'text-primary',
  xls: 'text-success', xlsx: 'text-success',
  ppt: 'text-warning', pptx: 'text-warning',
  zip: 'text-purple', rar: 'text-purple', '7z': 'text-purple',
  txt: 'text-muted', md: 'text-muted'
};
export function getFileColorClass(ext) {
  return COLOR_MAP[ext] || 'text-secondary';
}

export function showError(dropArea, message) {
  dropArea.addClass('error');
  const errorMsg = $(`<div class="text-danger small mt-2">${message}</div>`);
  dropArea.after(errorMsg);
  setTimeout(() => {
    errorMsg.fadeOut(() => errorMsg.remove());
    dropArea.removeClass('error');
  }, 5000);
}

export function checkPrefilledValues(widget) {
    const type = widget.data('type');
    const dropArea = widget.find('.drop-area');
    const filename = dropArea.data('filename');
    const src = dropArea.data('src');

    const placeholder = widget.find('.upload-placeholder');
    const previewContainer = widget.find('.preview-container');

    // Если есть имя файла и это FileUploadWidget
    if (type === 'file' && filename) {
        const extension = getFileExtension(filename);
        const colorClass = getFileColorClass(extension);
        const fileIcon = widget.find('.file-icon');
        const fileExtension = widget.find('.file-extension');
        const fileName = widget.find('.file-name');

        // Настраиваем иконку и текст
        fileIcon
            .removeClass('text-danger text-primary text-success text-warning text-purple text-muted text-secondary')
            .addClass(colorClass);
        fileExtension.text(extension.toUpperCase());
        fileName.text(filename).attr('title', filename);

        // Показ превью, скрытие плейсхолдера
        placeholder.hide();
        previewContainer.show();
    }

    // Если есть src и это ImageUploadWidget
    if (type === 'image' && src) {
        const previewImage = widget.find('.preview-image');

        // Устанавливаем источник и показываем превью
        previewImage.attr('src', src);
        placeholder.hide();
        previewContainer.show();
    }
}
